import { render, staticRenderFns } from "./online-portal-post-login-header.vue?vue&type=template&id=9754aa6e&"
import script from "./online-portal-post-login-header.vue?vue&type=script&lang=ts&"
export * from "./online-portal-post-login-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports